import * as React from 'react';
import { styled } from 'styled-components';

import { SpaceBetween, tk, Typography } from '@sunwebgroup/ui-components';

import { BusCard } from './BusCard';
import { Column } from '../Column';
import { useBusSelector } from '@/domain/prices/transports/hooks';
import { useIntl } from '@/intl';
import { ArrivalTitle, DepartureTitle } from '../FlightSelector/Headers';

const Wrapper = styled.div`
  display: flex;
  width: 100%;

  ${Column}:first-child {
    margin-right: ${tk('spacing_md')};
  }
`;

export const BusSelectorDesktop = () => {
  const {
    inboundRoutes,
    outboundRoutes,
    selectedInboundRouteId,
    selectedOutboundRouteId,
    setInboundRouteId,
    setOutboundRouteId,
  } = useBusSelector();
  const intl = useIntl();
  return (
    <>
      <Typography $variant="heading-lg">
        {intl.formatMessage({ id: 'prices_transport_selector_bus-selector_title' })}
      </Typography>
      <Wrapper>
        <Column>
          <DepartureTitle />
          <SpaceBetween direction="y" spacing={tk('spacing_md')}>
            {outboundRoutes.map((item, index) => (
              <BusCard
                key={index}
                {...item}
                setSelected={setOutboundRouteId}
                isSelected={selectedOutboundRouteId === item.id}
              />
            ))}
          </SpaceBetween>
        </Column>
        <Column>
          <ArrivalTitle />
          <SpaceBetween direction="y" spacing={tk('spacing_md')}>
            {inboundRoutes.map((item, index) => (
              <BusCard
                key={index}
                {...item}
                setSelected={setInboundRouteId}
                isSelected={selectedInboundRouteId === item.id}
              />
            ))}
          </SpaceBetween>
        </Column>
      </Wrapper>
    </>
  );
};
